import { Navigate, Outlet } from 'react-router-dom'

import { useSession } from 'auth/ui/hooks/useSession'

export default function PrivatePage() {
  const session = useSession()

  if (!session) return <Navigate to="/" />

  return <Outlet />
}
